import { alpha, Box, Button, styled } from '@mui/material';

const MainContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 0,
  flex: 1,
  minWidth: 0,
}));

const ViewsContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  overflowX: 'auto',
  overflowY: 'hidden',
  flex: '1 1 auto',
  minWidth: 0,
  paddingBottom: '12px',
  marginBottom: '-8px',
  scrollbarWidth: 'thin',
  scrollbarGutter: 'stable',
  '&::-webkit-scrollbar': {
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ccc',
    borderRadius: '3px',
    '&:hover': {
      backgroundColor: '#aaa',
    },
  },
}));

const ViewButtonContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  flexShrink: 0,
  marginLeft: '8px',
  '&:first-of-type': {
    marginLeft: 0,
  },
}));

const StyledViewButton = styled(Button)<{ isActive?: boolean }>(({ theme, isActive }) => {
  const accent = theme.palette.primary.main;
  const activeBg = alpha(accent, 0.14);
  const hoverBg = alpha(accent, 0.08);
  const activeHoverBg = alpha(accent, 0.20);

  return {
    maxWidth: '220px',
    minWidth: 'auto',
    textTransform: 'none',
    borderRadius: '20px',
    padding: '4px 12px',
    backgroundColor: isActive ? activeBg : 'transparent',
    color: accent,
    border: `1px solid ${alpha(accent, 0.35)}`,
    fontWeight: isActive ? 600 : 400,
    '&:hover': {
      backgroundColor: isActive ? activeHoverBg : hoverBg,
      border: `1px solid ${accent}`,
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1rem',
      marginRight: '4px',
    },
    '& .button-text': {
      display: 'block',
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  };
});

export { MainContainer, ViewsContainer, ViewButtonContainer, StyledViewButton };

